"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _phone = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/phone"));

var _mapMarker = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/map-marker"));

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../const");

var _useMedia = require("../../hooks/use-media");

var _lazyLoadImage = require("../lazy-load-image");

var _helpers = require("./helpers");

var _storeLocator = require("./store-locator.styled");

var _const2 = require("./const");

var _storeHours = _interopRequireDefault(require("./store-hours"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreLocatorModal = function StoreLocatorModal(props) {
  var changeLocationLink = props.changeLocationLink,
      changeLocationLinkText = props.changeLocationLinkText,
      makeAnAppointmentLink = props.makeAnAppointmentLink,
      makeAnAppointmentLinkText = props.makeAnAppointmentLinkText,
      closestLocation = props.closestLocation,
      livePersonID = props.livePersonID;
  var active = closestLocation.active,
      _closestLocation$loca = closestLocation.location,
      address1 = _closestLocation$loca.address1,
      address2 = _closestLocation$loca.address2,
      state = _closestLocation$loca.state,
      postalCode = _closestLocation$loca.postalCode,
      city = _closestLocation$loca.city,
      building = _closestLocation$loca.building,
      phone = closestLocation.phone,
      hours = closestLocation.hours,
      storeId = closestLocation.storeId;
  var storeImage = _const2.AEM_URL + "/content/dam/aem-integration/stores/Store_".concat(Number(storeId), ".jpg");
  var isTablet = (0, _useMedia.useMedia)(_const.Breakpoints.TABLET);
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var isMobileDevice = isMobile || isTablet;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Box, null, /*#__PURE__*/_react.default.createElement(_uiKit.Row, null, /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    md: 7
  }, /*#__PURE__*/_react.default.createElement(_storeLocator.ImageWrap, {
    isFullOnSize: "mobile"
  }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
    src: storeImage,
    placeholderSrc: _const2.DEFAULT_STORE_IMAGE,
    alt: "store image"
  }))), /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    md: 5
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    mt: isMobile && 20,
    color: "gray800"
  }, /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionStyled, null, /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionIconStyled, null, /*#__PURE__*/_react.default.createElement(_mapMarker.default, {
    measure: 14
  })), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionContentStyled, null, building && /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionHeadStyled, null, building), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionHeadStyled, null, address2 ? "".concat(address1, ", ").concat(address2) : address1), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactTextStyled, null, "".concat(city, ", ").concat(state ? state : '', " ").concat(postalCode)))), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionStyled, {
    m: [15, 0]
  }, /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionIconStyled, null, /*#__PURE__*/_react.default.createElement(_phone.default, {
    measure: 14
  })), /*#__PURE__*/_react.default.createElement(_storeLocator.ContactSectionContentStyled, null, /*#__PURE__*/_react.default.createElement(_storeLocator.ContactTextStyled, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:".concat(phone)
  }, (0, _helpers.maskedString)(phone, '(###) ###-####'))))), /*#__PURE__*/_react.default.createElement(_storeHours.default, {
    hours: hours,
    isClosed: !active,
    livePersonID: livePersonID
  })), changeLocationLink && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    as: "a",
    href: changeLocationLink,
    color: "gray800",
    variant: "underlined",
    mt: 30
  }, changeLocationLinkText), !isMobileDevice && makeAnAppointmentLink && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    fullWidth: true,
    as: "a",
    href: makeAnAppointmentLink,
    color: "gray800",
    variant: "outlined",
    mt: 30
  }, makeAnAppointmentLinkText))), isMobileDevice && makeAnAppointmentLink && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    fullWidth: true,
    as: "a",
    href: makeAnAppointmentLink,
    color: "gray800",
    variant: "outlined",
    mt: 30
  }, makeAnAppointmentLinkText));
};

var _default = StoreLocatorModal;
exports.default = _default;